import styled from "styled-components";
import { colors } from "@/theme";

export const ProductCatalogContainer = styled.div`
  &[data-disabled="true"] {
    pointer-events: none;
    opacity: 0.4;
  }
`;

export const ProductCatalogSearch = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 24px 0;
`;

export const ProductCatalogSearchLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const ProductCatalogSearchLabel = styled.h1`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 36px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const ProductCatalogSearchSubLabel = styled.p`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
`;

export const ProductCatalogInfiniteScrollContainer = styled.div`
  & div .infinite-scroll-component {
    overflow-y: hidden !important;
  }
`;
